import React from 'react';
import ArtifactViewCodeDiffHeader from '~/artifact/components/ArtifactViewCodeDiffHeader';
import ArtifactViewCodeDiffDisplay from '~/artifact/components/ArtifactViewCodeDiffDisplay';
type ArtifactViewMainContentFixInfoHowToFixPackageManagerSBTProps = {
  component: object;
  range: object;
  safeVersion?: string;
  unsafeVersion?: object;
  transitive?: boolean;
};
const ArtifactViewMainContentFixInfoHowToFixPackageManagerSBT: React.SFC<
  ArtifactViewMainContentFixInfoHowToFixPackageManagerSBTProps
> = props => {
  let component = props.component,
    range = props.range || {},
    safeVersion = props.safeVersion,
    unsafeVersion =
      props.unsafeVersion ||
      (range.versionRange && range.versionRange.indexOf('-') !== -1
        ? range.versionRange.split('-')[0]
        : ''),
    transitive = props.transitive == undefined ? false : props.transitive;
  if (!transitive) {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="build.sbt" />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="delete"
          text={
            'libraryDependencies += \u0022' +
            component.coordinate1 +
            '\u0022 % \u0022' +
            component.coordinate2 +
            '\u0022 % \u0022' +
            unsafeVersion +
            '\u0022'
          }
        />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={
            'libraryDependencies += \u0022' +
            component.coordinate1 +
            '\u0022 % \u0022' +
            component.coordinate2 +
            '\u0022 % \u0022' +
            safeVersion +
            '\u0022'
          }
        />
        <ArtifactViewCodeDiffDisplay type="normal" text={'\u00B7\u00B7\u00B7'} />
      </div>
    );
  } else {
    return (
      <div className="grid bo--1 border-color--white-dark mt lh+">
        <ArtifactViewCodeDiffHeader text="build.sbt" />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u00B7\u00B7\u00B7'} />
        <ArtifactViewCodeDiffDisplay
          type="add"
          text={
            'libraryDependencies += \u0022' +
            component.coordinate1 +
            '\u0022 % \u0022' +
            component.coordinate2 +
            '\u0022 % \u0022' +
            safeVersion +
            '\u0022'
          }
        />
        <ArtifactViewCodeDiffDisplay type="add" text={'\u00B7\u00B7\u00B7'} />
      </div>
    );
  }
};
export default ArtifactViewMainContentFixInfoHowToFixPackageManagerSBT;
